import { createFileRoute } from '@tanstack/react-router';
import { FileQuestion } from 'lucide-react';

import { QualitySurveyFooter } from '../@components/Footer';
import { QualitySurveyHeader } from '../@components/Header';
import { SurveyStatusContent } from '../@components/StatusContent';

export const Route = createFileRoute(
  '/_layout/$lang/quality-survey/_layout/not-found',
)({
  component: NotFound,
});

function NotFound() {
  return (
    <div className="grid min-h-screen grid-rows-[auto_1fr_auto]">
      <QualitySurveyHeader />
      <SurveyStatusContent
        icon={FileQuestion}
        iconBgClassName="bg-slate-100"
        iconClassName="text-slate-500"
        messageKey="survey.not_found.message"
        titleKey="survey.not_found.title"
      />
      <QualitySurveyFooter />
    </div>
  );
}
